<!--

	Page where you can search for frequently asked questions

-->

<template>
	<div class="mia-FAQ">
		<list-store-registration :store="listStore" :initial-data="initialData" />
		<conversion-store-registration :store="conversionStore" :initial-conversions="conversions" />	
		<searchable-list :store="listStore" :data="filteredCategoryKeys">
			<template #search-form>
				<div class="mia-faqSearch">
					<label v-tr="'faq_search'" for="searchInput" class />
					<search-input id="searchInput" v-model="searchQuery" :placeholder="$tr('searchbox.search_in_faq')" />
				</div>
			</template>
			<vue-list 
				:items="listStore" 
				:conversions="conversionStore" 
				template="category-answered-questions" 
				:item-props="{
					expandedQuestionWhenSearchQueryIsEmpty,
					setExpandedQuestionWhenSearchQueryIsEmpty,
					searchQuery,
					filteredCategoryAnsweredQuestions,
					targetQuestion,
				}"
			/>
		</searchable-list>
	</div>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import { MiaPlaza } from "@/Reinforced.Typings";
import VueList from "@/Control/Vue/Lists/VueList/VueList.vue";
import ConversionStoreRegistration from "@/Control/Vue/Stores/VueList/ConversionStoreRegistration";
import ListStoreRegistration from "@/Control/Vue/Stores/VueList/ListStoreRegistration";
import SearchInput from "@/Control/Vue/SearchInput.vue";
import SearchableList from "@/Control/Vue/Lists/Searchable/SearchableList.vue";

@Component({
	components: {
		VueList,
		ConversionStoreRegistration,
		ListStoreRegistration,
		SearchInput,
		SearchableList
	}
})
export class FAQ extends Vue {
	@Prop({ required: true, type: Array }) categoriesAnsweredQuestions!: MiaPlaza.ConfigModel.FAQ.IFAQCategory[];
	@Prop({ required: false, type: Object, default: null }) targetQuestion!: MiaPlaza.ConfigModel.FAQ.IAnsweredQuestion | null;

	conversionStore = "faq-conversion";
	listStore = "faq-list";
	expandedQuestionWhenSearchQueryIsEmpty: string | null = null;
	searchQuery = "";
	
	setExpandedQuestionWhenSearchQueryIsEmpty(question: string) {
		this.expandedQuestionWhenSearchQueryIsEmpty = question;
	}

	get conversions() {
		const categoriesAnsweredQuestions: {[category: string]: MiaPlaza.ConfigModel.FAQ.IFAQCategory } = { }
		for(const categoryAnsweredQuestions of this.categoriesAnsweredQuestions) {
			categoriesAnsweredQuestions[categoryAnsweredQuestions.Category] = categoryAnsweredQuestions;
		}
		return categoriesAnsweredQuestions;
	}

	get initialData() {
		return {
			Items: this.filteredCategoryKeys,
			TotalCountEstimate: this.filteredCategoryKeys.length,
			UnfilteredLimit: 0,
			UnfilteredOffset: 0
		};
	}

	get filteredCategoryAnsweredQuestions() {
		return this.categoriesAnsweredQuestions.map(categoryAnsweredQuestions => {
			if(this.isValueIncludesSearchQuery(categoryAnsweredQuestions.Category)) {
				return categoryAnsweredQuestions;
			}
			return this.questionOrAnswerIncludesSearchQuery(categoryAnsweredQuestions);
		})
		.filter(categoryAnsweredQuestions => categoryAnsweredQuestions.AnsweredQuestions.length !== 0);
	}

	get filteredCategoryKeys() {
		return this.filteredCategoryAnsweredQuestions.map(categoryAnsweredQuestions => categoryAnsweredQuestions.Category);
	}

	isValueIncludesSearchQuery(value: string): boolean {
		return value.toLowerCase().includes(this.searchQuery.trim().toLowerCase());
	}

	questionOrAnswerIncludesSearchQuery(categoryAnsweredQuestions: MiaPlaza.ConfigModel.FAQ.IFAQCategory): MiaPlaza.ConfigModel.FAQ.IFAQCategory {
		return {
			Category: categoryAnsweredQuestions.Category,
			AnsweredQuestions: categoryAnsweredQuestions.AnsweredQuestions.filter(questionWithAnswer =>
				this.isValueIncludesSearchQuery(questionWithAnswer.Question)
				|| this.isValueIncludesSearchQuery(questionWithAnswer.Answer))
		};
	}
}

export default toNative(FAQ);
</script>
<style lang="scss">
.mia-FAQ {
	.mia-faqSearch {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: theme.$mia-margin-size-xl theme.$mia-margin-size-xxl;

		label {
			font-weight: 400;
			font-size: theme.$font-size-h5;
			padding-top: theme.$mia-padding-panel-small;
			padding-right: theme.$mia-padding-panel;
		}
	}
}
</style>
